import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component, OnInit, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { BusinessSalesSummary, DashboardService } from '../../core/services/dashboard.service';
import { httpErrorMessage } from '../../core/utils/http-error-message';

@Component({
  selector: 'app-dashboard',
  imports: [CurrencyPipe, DatePipe],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.scss',
})
export class Dashboard implements OnInit {
  private readonly dashboardService = inject(DashboardService);
  private readonly router = inject(Router);

  get isBusinessPortal(): boolean { return this.router.url.startsWith('/business'); }
  get subscriptionName(): string { return this.stats().find((item) => item.label === 'Subscription')?.value ?? ''; }
  get isInternalSubscription(): boolean { return this.subscriptionName === 'ZepBazaar Internal'; }

  openBusinesses(): void { void this.router.navigate(['/admin/businesses']); }
  openPlans(): void { if (!this.isInternalSubscription) void this.router.navigate(['/business/plan-selection']); }

  readonly stats = signal([
    { label: 'Active users', value: '45', detail: '+6 this month' },
    { label: 'Roles', value: '8', detail: '3 system roles' },
    { label: 'Permissions', value: '32', detail: '6 modules covered' },
    { label: 'Businesses', value: '4', detail: 'All verified' },
  ]);

  readonly activity = signal([
    'Manager role granted to Priya Shah',
    'Inventory export permission enabled',
    'New cashier invited to Downtown branch',
    'Business profile verification completed',
  ]);

  readonly isLoading = signal(false);
  readonly errorMessage = signal('');
  readonly salesLoading = signal(false);
  readonly salesError = signal('');
  readonly sales = signal<BusinessSalesSummary | null>(null);

  ngOnInit(): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.dashboardService
      .summary()
      .subscribe({
      next: (summary) => {
        this.stats.set(summary.stats);
        this.activity.set(summary.activity);
        this.isLoading.set(false);
      },
      error: (error: unknown) => {
        this.isLoading.set(false);
        this.errorMessage.set(httpErrorMessage(error, 'Dashboard API is unavailable.'));
      },
    });

    if (this.isBusinessPortal) {
      this.salesLoading.set(true);
      this.dashboardService.businessSales().subscribe({
        next: (summary) => {
          this.sales.set(summary);
          this.salesLoading.set(false);
        },
        error: (error: unknown) => {
          this.salesLoading.set(false);
          this.salesError.set(httpErrorMessage(error, 'Sales overview is unavailable.'));
        },
      });
    }
  }
}
